export const ATTACHMENT_BUCKET = 'task-attachments'
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024

export type TaskAttachment = {
  name: string
  path: string
  size: number
  mimeType: string
}

const allowedMimeTypes = new Set([
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xml',
  'text/xml',
  'application/zip',
  'application/x-zip-compressed',
])

const allowedExtensions = new Set([
  'pdf', 'jpg', 'jpeg', 'png', 'webp', 'doc', 'docx', 'xls', 'xlsx', 'xml', 'zip',
])

const mimeByExtension: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xml: 'application/xml',
  zip: 'application/zip',
}

export function resolvedAttachmentMimeType(file: Pick<File, 'name' | 'type'>): string {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? ''
  return allowedMimeTypes.has(file.type) ? file.type : (mimeByExtension[extension] ?? file.type)
}

export function attachmentError(file: Pick<File, 'name' | 'size' | 'type'>): string | null {
  if (file.size > MAX_ATTACHMENT_BYTES) return 'Cada arquivo deve ter no máximo 10 MiB.'
  const extension = file.name.split('.').pop()?.toLowerCase() ?? ''
  if (!allowedExtensions.has(extension) || !allowedMimeTypes.has(resolvedAttachmentMimeType(file))) {
    return 'Tipo não permitido. Use PDF, imagem, Word, Excel, XML ou ZIP.'
  }
  return null
}

export function sanitizeAttachmentName(name: string): string {
  const normalized = name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/-+\./g, '.')
    .replace(/^[-.]+|[-.]+$/g, '')
  return normalized || 'arquivo'
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KiB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MiB`
}
